import { useEffect, useState } from "react";
import api from "../api";
import { useNavigate, useParams } from "react-router-dom";
import { Bounce, toast } from "react-toastify";
import "./sedi.css";

const EditSedi = () => {
  const [loading, setLoading] = useState(false);
  const [sede, setSede] = useState(null);
  const [indirizzoSede, setIndirizzoSede] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [error, setError] = useState("");

  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const userRole = localStorage.getItem("userRole");
    if (userRole !== "ADMIN") {
      alert("Accedi come amministratore per modificare le sedi!");

      localStorage.clear();
      navigate("/login");
    } else {
      fetchSedi();
    }
  }, [navigate]);

  const fetchSedi = async () => {
    try {
      setLoading(true);
      const res = await api.get(`/sedi/${id}`);
      if (res.status === 200) {
        const data = res.data;
        setSede(data);
        setIndirizzoSede(data.indirizzoSede || "");
      } else {
        toast.error("Sede non trovata!", toastOptions());
      }
    } catch (error) {
      console.error("Errore caricamento sede:", error);
      toast.error(error?.response?.data?.message, toastOptions());
    } finally {
      setLoading(false);
    }
  };

  const toastOptions = () => ({
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
    transition: Bounce,
  });

  const isValid = () => {
    if (!indirizzoSede.trim()) {
      setError("Il campo Indirizzo della Sede non può essere vuoto!");
      return false;
    }
    setError("");
    return true;
  };

  const handleSave = async () => {
    if (!isValid()) return;
    try {
      setLoading(true);
      const response = await api.put(`/sedi/${id}`, { indirizzoSede });
      if (response.status === 200) {
        toast.success("Modifiche salvate con successo!", toastOptions());
        setSede({ ...sede, indirizzoSede });
        setEditMode(false);
      } else {
        toast.error("Qualcosa è andato storto!", toastOptions());
      }
    } catch (error) {
      console.error("Errore salvataggio:", error);
      toast.error(error?.response?.data?.message, toastOptions());
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setIndirizzoSede(sede?.indirizzoSede || "");
    setEditMode(false);
    setError("");
  };

  const getMapAddress = (fullAddress) => {
    if (!fullAddress) return "";
    return fullAddress.replace(/\s*\d{5}\s*/, " ");
  };

  if (loading || !sede)
    return (
      loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )
    );

  return (
    <div className="content-page">
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

      <div className="page-header">
        <div className="page-title">Modifica Sede</div>
        <div className="header-actions">
          <button onClick={() => navigate("/sedi")} className="back-btn">
            <i className="fa-solid fa-arrow-left"></i>
            Torna alle Sedi
          </button>
        </div>
      </div>

      <div className="page-content edit-sedi-container">
        <div className="edit-sedi-card">
          <div className="card-header">
            <div className="card-title">
              <i className="fa-solid fa-building"></i>
              Dettagli Sede
            </div>
            {!editMode && (
              <button className="edit-btn" onClick={() => setEditMode(true)}>
                <i className="fa-solid fa-edit"></i>
                Modifica
              </button>
            )}
          </div>

          <div className="card-content">
            <div className="form-field">
              <label className="field-label">
                <i className="fa-solid fa-map-marker-alt"></i>
                Indirizzo Sede
              </label>
              <div className="field-input">
                {!editMode ? (
                  <div className="readonly-value">{sede.indirizzoSede}</div>
                ) : (
                  <input
                    type="text"
                    value={indirizzoSede}
                    onChange={(e) => {
                      setIndirizzoSede(e.target.value);
                      if (error) setError("");
                    }}
                    placeholder="Inserisci l'indirizzo della sede"
                    className={error ? "error-input" : ""}
                  />
                )}
                {error && <div className="error-message">{error}</div>}
              </div>
            </div>

            {editMode && (
              <div className="action-buttons">
                <button className="cancel-btn" onClick={handleCancel}>
                  <i className="fa-solid fa-times"></i>
                  Annulla
                </button>
                <button className="save-btn" onClick={handleSave}>
                  <i className="fa-solid fa-check"></i>
                  Salva Modifiche
                </button>
              </div>
            )}
          </div>
        </div>

        {sede?.operatori && sede.operatori.length > 0 && (
          <div className="edit-sedi-card">
            <div className="card-header">
              <div className="card-title">
                <i className="fa-solid fa-users"></i>
                Operatori ({sede.operatori.length})
              </div>
            </div>
            <div className="card-content">
              <div className="operatori-list">
                {sede.operatori.map((operatore) => (
                  <div key={operatore.id} className="operatore-item">
                    <div className="operatore-header">
                      <div className="operatore-name">
                        <i className="fa-solid fa-user"></i>
                        {operatore.nome} {operatore.cognome}
                      </div>
                      <div className="operatore-status">
                        <span className={`status-badge ${operatore.enabled ? 'enabled' : 'disabled'}`}>
                          {operatore.enabled ? 'Abilitato' : 'Disabilitato'}
                        </span>
                        {operatore.locked && (
                          <span className="status-badge locked">
                            <i className="fa-solid fa-lock"></i> Bloccato
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="operatore-details">
                      <div className="operatore-detail-item">
                        <i className="fa-solid fa-envelope"></i>
                        <span className="detail-label">Email:</span>
                        <span className="detail-value">{operatore.email}</span>
                      </div>
                      {operatore.descrizione && (
                        <div className="operatore-detail-item">
                          <i className="fa-solid fa-info-circle"></i>
                          <span className="detail-label">Descrizione:</span>
                          <span className="detail-value">{operatore.descrizione}</span>
                        </div>
                      )}
                      <div className="operatore-detail-item">
                        <i className="fa-solid fa-id-card"></i>
                        <span className="detail-label">ID:</span>
                        <span className="detail-value">{operatore.id}</span>
                      </div>
                      {operatore.dataCreazione && (
                        <div className="operatore-detail-item">
                          <i className="fa-solid fa-calendar-plus"></i>
                          <span className="detail-label">Data Creazione:</span>
                          <span className="detail-value">
                            {new Date(operatore.dataCreazione).toLocaleString('it-IT')}
                          </span>
                        </div>
                      )}
                      {operatore.dataUltimaModifica && (
                        <div className="operatore-detail-item">
                          <i className="fa-solid fa-calendar-edit"></i>
                          <span className="detail-label">Ultima Modifica:</span>
                          <span className="detail-value">
                            {new Date(operatore.dataUltimaModifica).toLocaleString('it-IT')}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {indirizzoSede && (
          <div className="map-card">
            <div className="card-header">
              <div className="card-title">
                <i className="fa-solid fa-map"></i>
                Mappa
              </div>
            </div>
            <div className="map-container">
              <iframe
                title="Map"
                style={{ border: 0, width: "100%", height: "400px" }}
                src={`https://www.google.com/maps?q=${encodeURIComponent(
                  getMapAddress(indirizzoSede)
                )}&output=embed`}
                allowFullScreen
              ></iframe>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EditSedi;
